// extracted by mini-css-extract-plugin
module.exports = {"confluenceContainer":"styles_confluenceContainer__3TDAp"};